import { useCallback } from "react";
import { UrlQueryFilter, useUrlQuery } from "../../../shared/hooks/useUrlQuery";

export interface BookkeepingDateRange {
  start: Date;
  end: Date;
}

export interface BookkeepingRangeFilter extends UrlQueryFilter {
  dateRange?: BookkeepingDateRange;
}

export const getDefaultBookkeepingRange = (): BookkeepingDateRange => {
  const now = new Date();
  return {
    start: new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0),
    end: new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999)
  };
};

export const isDefaultBookkeepingRange = (range: BookkeepingDateRange) => {
  const defaultRange = getDefaultBookkeepingRange();
  return (
    range.start.valueOf() === defaultRange.start.valueOf() &&
    range.end.valueOf() === defaultRange.end.valueOf()
  );
};

export function useBookkeepingDateRange() {
  const { urlQuery, setUrlQuery } = useUrlQuery<BookkeepingRangeFilter>();

  const stored = urlQuery.filter.dateRange as BookkeepingDateRange | undefined;
  const range =
    stored && stored.start && stored.end
      ? stored
      : getDefaultBookkeepingRange();

  const setRange = useCallback(
    (next: BookkeepingDateRange) => {
      setUrlQuery(prev => ({
        ...prev,
        filter: { ...prev.filter, dateRange: next }
      }));
    },
    [setUrlQuery]
  );

  return { range, setRange };
}
